module.exports = __webpack_public_path__ + "img/About2.024e7bd5.png";